import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

import errorHandler from 'lib/utils/errorHandler';
import { Url } from 'utils/url';

function SsoSessionSync(props) {
  const [checkSessionEndpointUrl, setCheckSessionEndpointUrl] = useState();
  const [clientCheckSessionUrl, setClientCheckSessionUrl] = useState();
  const style = { display: 'none' };

  useEffect(() => {
    if (!clientCheckSessionUrl) {
      const url = new Url('/webshop/sso/client-check-session.go')
        .addQueryParameter('referrer', props.currentRoute)
        .toString();

      setClientCheckSessionUrl(url);
    }

    if (!checkSessionEndpointUrl) {
      props.getSsoCheckSessionUrl().then(result => {
        setCheckSessionEndpointUrl(result);
      }).catch(errorHandler);
    }
  }, []);

  const isSessionSyncEnabled =
    props.betaFeatures
    && props.cookiesEnabled
    && props.betaFeatures.includes('SSO_SESSION_SYNCHRONIZATION')
    && props.viewMode !== 'EMBEDDED_IN_MOBILE_APP'
    && !props.isSuperuser;

  // if we render the iFrames on /login page they send a request to "check session" endpoint in Webshop
  // this causes a bug in Webshop with two different session strings (one generated by Raven and one by Webshop after SSO login)
  const isLoginPathname = get(props, 'location.pathname') === '/login';

  if (!isSessionSyncEnabled || !checkSessionEndpointUrl || !clientCheckSessionUrl || isLoginPathname) {
    return null;
  }

  return (
    <>
      <iframe style={style} title="sessionSSoIframeUrl" id="js-opframe" src={checkSessionEndpointUrl} />
      <iframe style={style} title="sessionClientIframeUrl" id="js-clientFrame" src={clientCheckSessionUrl} />
    </>
  );
}

SsoSessionSync.propTypes = {
  betaFeatures: PropTypes.array.isRequired,
  cookiesEnabled: PropTypes.bool,
  currentRoute: PropTypes.string.isRequired,
  getSsoCheckSessionUrl: PropTypes.func,
  viewMode: PropTypes.string,
  isSuperUser: PropTypes.bool,
};

export default SsoSessionSync;
